import React from "react";

import { IoIosSearch } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import { Button } from "primereact/button";

function SearchTable({
  libelleBtn,
  isBtn,
  isSearch,
  placeholderInputSearch,
  globalFilterValue,
  handleChange,
  nameRouteBtn,
  iconeBtn,
  isBtnExcel,
  btnFilterArray,
  isBtnFilter,
  exportExcel
}) {
  const navigate = useNavigate();
  return (
    <div
      style={{ justifyContent: (isBtn || isBtnExcel || isBtnFilter) ? "space-between" : "flex-end" }}
      className="d-flex  align-items-center"
    >
     
       {
        isBtn && <button
        onClick={() => navigate(`${nameRouteBtn}`)}
        className="btn-lg border-0 rounded-3 p-2 text-dark fw-bold"
        style={{ background: "var(--primary-color)" }}
      >
        {iconeBtn} {libelleBtn}
      </button>
      }
      {
        isBtnExcel && <Button
        type="button"
        label="Excel format"
        icon="pi pi-file-excel"
        style={{
          border: "none",
          color: "black",
          margin: "1em 0",
          background: "var(--primary-color)"
        }}
        onClick={exportExcel}
        data-pr-tooltip="XLS"
      />
      }
      {
        isBtnFilter && <BtnFilterWithOption  btnFilterArray={btnFilterArray} />
      }
       
      {isSearch && (
        <div className="position-relative w-25 p-0">
          <IoIosSearch
            fontSize={"1.5em"}
            style={{ position: "absolute", top: "32px" }}
          />
          <input
            type="search"
            placeholder={placeholderInputSearch}
            className=" w-100 py-4 px-4  rounded-2 border-1"
            value={globalFilterValue}
            onChange={handleChange}
            name="search"
            id="search"
          />
        </div>
      )}
    </div>
  );
}

const BtnFilterWithOption = ({btnFilterArray})=>{
  return(
    <div className="d-flex align-items-center flex-wrap gap-3">
      {
        btnFilterArray.map((item,index)=>(
     <button className="p-1 border-1 rounded"
     style={{
      backgroundColor:item.isClickOn === item.libelle ? 'blue':null,
      color:item.isClickOn === item.libelle ? 'white':null}}
     key={index} onClick={item.methode} 
     value={item.libelle}>{item.libelle}</button>
        ))
      }
 
    {/* <button onClick={chooseDataPayer} value='payer'>payer</button> */}
     </div>
  )
}

export default SearchTable;
